import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';

import { fetchAllUsers } from '../../state/users';
import { fetchOrgUsers } from '../../state/orgUsers';
import { fetchAllOrgs } from '../../state/orgs';
import PageTitle from '../../components/PageTitle';
import SSOButton from '../../components/SSOButton';
import AddIcon from '../../icons/AddIcon';
import UsersTable from '../../components/tables/UsersTable';
import { HeadlineContainer } from '../../components/form/FormStyles';

class ListUsers extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const {
      fetchAllUsers, isAllUsersLoaded, isOrgUsersLoaded, fetchOrgUsers,
      fetchAllOrgs, isAllOrgsLoaded,
    } = this.props;

    if (!isAllUsersLoaded) {
      fetchAllUsers();
    }

    if (!isOrgUsersLoaded) {
      fetchOrgUsers();
    }

    if (!isAllOrgsLoaded) {
      fetchAllOrgs();
    }
  }

  handleAddNewUserClick() {
    const { history } = this.props;
    history.push('/users/new');
  }

  render() {
    const { t, isAllUsersLoaded, users } = this.props;

    if (!isAllUsersLoaded) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <PageTitle title={t('Pages.Users.Headlines.Title')} />
          <SSOButton
            id="Users.AddNewUser"
            icon={AddIcon}
            onClick={this.handleAddNewUserClick}
            text={t('Pages.Users.Actions.AddUser')}
            isSmall
          />
        </HeadlineContainer>

        <UsersTable users={users} />
      </div>
    );
  }
}

ListUsers.propTypes = {
  fetchOrgUsers: PropTypes.func.isRequired, // supplied from Redux
  isOrgUsersLoaded: PropTypes.bool.isRequired, // supplied from Redux
  fetchAllUsers: PropTypes.func.isRequired, // supplied from Redux
  isAllUsersLoaded: PropTypes.bool.isRequired, // supplied from Redux
  fetchAllOrgs: PropTypes.func.isRequired, // supplied from Redux
  isAllOrgsLoaded: PropTypes.bool.isRequired, // supplied from Redux
  users: PropTypes.array.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
  history: PropTypes.object.isRequired, // supplied from React Router
};

const mapStateToProps = state => ({
  isAllUsersLoaded: state.users.isAllUsersLoaded,
  isOrgUsersLoaded: state.orgUsers.isOrgUsersLoaded,
  isAllOrgsLoaded: state.orgs.isAllOrgsLoaded,
  users: state.users.users,
});

const mapDispatchToProps = {
  fetchAllUsers,
  fetchOrgUsers,
  fetchAllOrgs,
};

const TranslatedComponent = withTranslation()(ListUsers);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
